import normalizeBreakpointsArray from './normalizeBreakpointsArray';

var expandVariants = function expandVariants(variant, themeObject) {
  return function (_ref) {
    var theme = _ref.theme;

    if (!variant) {
      return null;
    }

    if (Array.isArray(variant)) {
      var normalizedValue = normalizeBreakpointsArray(variant, theme);
      return normalizedValue.map(function (v, i) {
        if (v && themeObject[v]) {
          return theme.normalizeStyles(themeObject[v], theme.viewportsArray[i]);
        }

        return false;
      }).filter(Boolean);
    } else if (themeObject[variant]) {
      return theme.normalizeStyles(themeObject[variant]);
    }

    return null;
  };
};

export default expandVariants;